import { render, staticRenderFns } from "./BrandSerieProductNav.vue?vue&type=template&id=4d8f85a8&scoped=true&"
import script from "./BrandSerieProductNav.vue?vue&type=script&lang=js&"
export * from "./BrandSerieProductNav.vue?vue&type=script&lang=js&"
import style0 from "./BrandSerieProductNav.vue?vue&type=style&index=0&id=4d8f85a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f85a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
